<template lang="html">
  <div id="header" class="parallaxbg">
    <password-reset
      :reason="currUser.reset_password_reason"
      :errorMessage="errorMessage"
      :resetPasswordResponse="resetPasswordResponse"
      @changePassword="changePassword"
      @viewLoginScreen="viewLoginScreen" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PasswordReset from '@common/components/PasswordReset';

export default {
  data() {
    return {
      resetPasswordResponse: false,
      errorMessage: null,
    };
  },
  components: {
    PasswordReset,
  },
  computed: {
    ...mapGetters({
      currUser: 'app/currentUser',
    }),
  },
  methods: {
    async changePassword(data) {
      try {
        const { result, errMsg } = await this.$store.dispatch('app/changeProfile', { data });
        if (result) {
          const optimaHeaders = localStorage.getItem('Optima-selected-headers');
          await this.$store.dispatch('app/logout',{ data: { } });
          if (optimaHeaders) {
            localStorage.setItem('Optima-selected-headers', optimaHeaders);
          }
          localStorage.setItem('tsm-user-token', '');
          this.resetPasswordResponse = true;
          this.errorMessage = null;
        } else {
          this.errorMessage = errMsg;
        }
        return { result, errMsg };
      } catch (err) {
        throw (err);
      }
    },
    viewLoginScreen() {
      const optimaHeaders = localStorage.getItem('Optima-selected-headers');
      this.$store.dispatch('app/logout',{ data: { } });
      if (optimaHeaders) {
        localStorage.setItem('Optima-selected-headers', optimaHeaders);
      }
      localStorage.setItem('tsm-user-token', '');
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
